<ng-container *ngIf="permConfig.isViewAllowed">
<div class="container-fluid">
    <app-page-title title="Supplementary Invoice Generation (View Only)"></app-page-title>
    <form [formGroup]="invoiceForm">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="billType" class="form-label">Bill Type<span class="mandatory">*</span></label>
                                    <ng-select id="billType" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlBillType" ></ng-select>
                                </div>
                            </div> 
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="company" class="form-label">Company<span class="mandatory">*</span></label>
                                    <ng-select id="company" formControlName="ddlCompany" [items]="companyList" [appendTo]="'body'" [openOnEnter]="false" bindLabel="name" [bindValue]="'id'" ></ng-select>
                                </div>
                            </div>
                            <div class="col-md-2" *ngIf="showServiceCenter">
                                <div class="mb-2">
                                    <label for="serviceCenter" class="form-label">Service Center<span class="mandatory">*</span></label>
                                    <ng-select id="serviceCenter" [items]="ServiceCenterOptions" bindLabel="name" placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlServiceCenter" ></ng-select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="invoiceDate" class="form-label">Invoice Date<span class="mandatory">*</span></label>
                                    <input id="invoiceDate" class="form-control form-control-sm" type="date" placeholder="Select" formControlName="txtInvoiceDate" >
                                </div>
                            </div> 
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="InvoiceNo" class="form-label">Invoice No.</label>
                                    <input type="text" formControlName="txtInvoiceNo" class="form-control form-control-sm" id="InvoiceNo" >
                                </div>
                            </div>
                            
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="toDate" class="form-label">BOE Date</label>
                                    <input id="toDate" class="form-control form-control-sm" type="date"placeholder="Select" formControlName="txtBOEDate" >
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="boeNo" class="form-label">BOE No.</label>
                                    <input type="text" maxlength="30" class="form-control form-control-sm" id="boeNo" formControlName="txtBOENo" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="awbNo" class="form-label">AWB No.<span class="mandatory">*</span></label>
                                    <input type="text" maxlength="30" class="form-control form-control-sm" id="awbNo" formControlName="txtAwbNo" >
                                </div>
                            </div>
                            <div class="col-md-1">
                                <div class="mb-2">
                                    <label for="itemfuel" class="form-label">Bill To</label>
                                    <div role="group" aria-label="Item fuel" class="btn-group btn-group-sm d-flex">
                                        <input type="radio" id="btnbillto1" autocomplete="off" checked="" class="btn-check"
                                            value="sender" (change)="'getChargeItemValue()'" formControlName="switchSenderRecv" />
                                        <label for="btnbillto1" class="btn btn-outline-secondary">Shipper</label>
                                        <input type="radio" id="btnbillto2" autocomplete="off" class="btn-check" 
                                            value="receiver" (change)="'getChargeItemValue()'" formControlName="switchSenderRecv" />
                                        <label for="btnbillto2" class="btn btn-outline-secondary">Consignee</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Bill To Details</div>
                        <div class="card-body">
                            <div  formGroupName="infoForm">
                            <div class="row" >                        
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="name" class="form-label">Name </label>
                                        <input type="text" class="form-control form-control-sm" id="name"
                                        placeholder="Search or Enter Name" 
                                        formControlName="txtName"/>                                   
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="conatctperson" class="form-label">Contact Person </label>
                                        <input type="text" class="form-control form-control-sm" id="conatctperson"
                                            formControlName="txtConatctPerson" >                            
                                    </div>
                                </div>
                            </div>
                        </div>
                            <app-location formGroupName="locationForm" [formSubmitted]="isFormSubmitted" [location]="locationInfo">
                        </app-location>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Billing Info</div>
                    <div class="card-body" formGroupName="billingoInfoForm">
                        <div class="row">
                            <div class="col-md-4">
                              <div class="">
                                <label for="documentType" class="form-label">Document Type</label>
                                <ng-select id="documentType" [items]="documentOptions" bindLabel="name" [bindValue]="'name'" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlDocumentType" placeholder="Select" >
                                </ng-select>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="mb-2">
                                <label for="documentNo" class="form-label">Document No.</label>
                                <input type="text" class="form-control form-control-sm" id="documentNo" formControlName="ddlDocumentNo" >
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                                <div class="mb-2">
                                    <label class="form-label" for="remark">Remark</label>
                                    <textarea id="remark" class="form-control custom-textbox fixed-height" placeholder="Optional" formControlName="txtRemark" ></textarea>
                                </div>
                            </div>
                          </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header bg-transparent border-bottom text-uppercase">Additional</div>
            <div class="card-body">
                <div class="row">
                    <div class="row">
                        <div class="col-md-12 grid-container">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                                [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [suppressMenuHide]="true"
                                [pagination]="true" (gridReady)="onGridReady($event)">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="button-items">
                    <a routerLink="/invoices/supplementary" >
                        <button type="button" class="btn btn-secondary w-sm">Cancel</button>
                    </a>
                </div>
            </div>
        </div>
    </form>
</div>
</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>
